import React from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import MobilePix from './MobilePix'
import DeskPix from './DeskPix'
import { useLocation } from 'react-router-dom'

export default function Pix() {
  const location = useLocation()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { sttCtxChkt, actionsPix } = React.useContext(CheckoutContext)

  React.useEffect(() => {
    document.title = 'Pagamento por PIX | Agendei Quadras'
    actionsPix.BuscarPagamentoPix(location.pathname.split('/').pop(), sttCtxChkt.modePay !== 'DIARIA')
  }, [])

  return <>{sttAuthCtx.isMobile ? <MobilePix /> : <DeskPix />}</>
}
